import React from 'react';

export default function EmptyValue(props: {
  groupName: string;
  showLabel: string | number;
}) {
  const { groupName, showLabel } = props;
  return (
    <div className="dbi-cascader-select-button-txt">{`${groupName}: ${showLabel}`}</div>
  );
}
